<template>
  <div class="row mt-4">
    <div v-for="(proTip, proTipIndex) in filteredProTips" v-bind:class="itemClass">
      <pro-tip-result :proTip="proTip">
        <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
          <slot :name="name" v-bind="slotData" />
        </template>
      </pro-tip-result>
    </div>
  </div>
  <button class="btn btn-secondary d-block mx-auto" v-if="displayLoadMoreButton" v-on:click="numberShown += increment">Load More</button>
</template>

<script>
  import ProTipResult from './pro-tip-listing/pro-tip-result.vue';

  

  import Globals from '../../scripts/globals';

  export default {
    components: {
      'pro-tip-result': ProTipResult
    },
    data() {
      let searchParams = new URLSearchParams(window.location.search);
      let d = window.wf.proTipListing;
      d.numberShown ??= -1;
      d.increment ??= d.numberShown;
      d.itemClass ??= "col-6 col-lg-3 mb-3";
      return d;
    },
    computed: {
      filteredProTips() {
        if (this.numberShown > -1) {
          return this.proTips.filter((el, index) => index < this.numberShown);
        } else {
          return this.proTips;
        }
      },
      displayLoadMoreButton() {
        if (this.proTips.length > this.numberShown && this.numberShown > -1) {
          return true;
        }
        return false;
      }
    },
    watch: {
      currentQuery: {
        handler: function() {
          this.updateLocation();
        },
        deep: true
      }
    },
    methods: {
    }
  }
</script>
